const requestFrame = (callback) => {
  return window.requestAnimationFrame(callback);
};

export default requestFrame;
